import { urls } from '@/constants/urls';
import { useCurrentGroup } from '@/hooks/use-current-group';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';

export const useAddNewUnitUrl = () => {
  const { isUsingOrganisationOverride, organisation } =
    useCurrentOrganisation();
  const { data: group } = useCurrentGroup();
  const orgId = organisation?.id as number;
  const groupId = group?.id as number;
  return isUsingOrganisationOverride
    ? urls.organisations.organisation.groups.group.new_unit.compose(
        orgId,
        groupId,
      )
    : urls.groups.group.new_unit.compose(groupId);
};
